var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-message",class:_vm.classes},[_c('div',{staticClass:"avatar"},[_vm._v(_vm._s(_vm.avatar))]),_c('v-card',{staticClass:"message",attrs:{"elevation":"0"}},[_vm._v(_vm._s(_vm.model.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }